import { sql } from "drizzle-orm";
import { boolean, check, integer, jsonb, pgTable, primaryKey, text, timestamp, unique, varchar } from "drizzle-orm/pg-core";
import type { HelpDocument, HelpScreenshotView } from "./help.js";
import { organisations, users } from "./schemaBase.js";

export const helpArticles = pgTable("help_articles", {
  id: varchar("id").primaryKey().default(sql`gen_random_uuid()`),
  organisationId: varchar("organisation_id").notNull().references(() => organisations.id, { onDelete: "cascade" }),
  slug: varchar("slug", { length: 100 }).notNull(),
  draft: jsonb("draft").$type<HelpDocument>().notNull(),
  published: jsonb("published").$type<HelpDocument>(),
  version: integer("version").notNull().default(1),
  publishedAt: timestamp("published_at", { withTimezone: true }),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
}, table => [unique().on(table.organisationId, table.slug), check("help_articles_version_check", sql`${table.version} > 0`)]);

export const helpRevisions = pgTable("help_revisions", {
  id: varchar("id").primaryKey().default(sql`gen_random_uuid()`),
  articleId: varchar("article_id").notNull().references(() => helpArticles.id, { onDelete: "cascade" }),
  version: integer("version").notNull(),
  document: jsonb("document").$type<HelpDocument>().notNull(),
  action: text("action").notNull(),
  actorId: varchar("actor_id").references(() => users.id, { onDelete: "set null" }),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => [unique().on(table.articleId, table.version), check("help_revisions_action_check", sql`${table.action} in ('create', 'save', 'publish', 'unpublish', 'restore')`)]);

export const helpImages = pgTable("help_images", {
  id: varchar("id").primaryKey().default(sql`gen_random_uuid()`),
  articleId: varchar("article_id").notNull().references(() => helpArticles.id, { onDelete: "cascade" }),
  objectKey: text("object_key").notNull(),
  contentType: text("content_type").notNull(),
  accountView: text("account_view").$type<HelpScreenshotView>().notNull(),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => [check("help_images_account_view_check", sql`${table.accountView} in ('student', 'parent', 'tutor')`)]);

export const helpFeedback = pgTable("help_feedback", {
  articleId: varchar("article_id").notNull().references(() => helpArticles.id, { onDelete: "cascade" }),
  userId: varchar("user_id").notNull().references(() => users.id, { onDelete: "cascade" }),
  helpful: boolean("helpful").notNull(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
}, table => [primaryKey({ columns: [table.articleId, table.userId] })]);
